export default __webpack_public_path__ + "static/python-back-end-web-63e886137fe280fd3ad72abb654a60a8.webp";